import React, { useState, useEffect, useRef, useCallback } from "react";
import { useClientSocket } from "../hooks/useClientSocket";
import CarImageGallery from "../components/livebid/CarImageGallery";
import CurrentBidBox from "../components/livebid/CurrentBidBox";
import BiddingActivityList from "../components/livebid/BiddingActivityList";
import AuctionVehicalsList from "../components/livebid/AuctionVehicalsList";
import CarHeader from "../components/cardetails/CarHeader";
import NotifictionBar from "../components/home/NotifictionBar";
import { infoIcons } from "../assets/VehicleDetailsIcon";
import { carIcon } from "../assets/VehicleDetailsIcon";
import { InfoItem } from "../assets/VehicleDetailsIcon";
import { useParams } from "react-router-dom";
import {
  getAuction,
  getCurrentVehicle,
  getVehicleList,
  getBidHistory,
} from "../services/auctionServices.ts";
import CircularTimer from "../components/circulartimer/CircularTimer.tsx";
import "../components/circulartimer/CircularTimer.css";
import { useConfetti } from "../hooks/useConfetti";
import { maskVinNumber } from "../utils/functions.js";
import CurrencyDisplay from "../components/common/CurrencyDisplay";
import { soundHelper } from "../utils/soundHelper.ts";
import api from "../lib/api.ts";

export default function MainAuctionPage({ carDetail }) {
  const [allCarsSold, setAllCarsSold] = useState(false);

  // Ref for the circular timer
  const timerRef = useRef(null);

  // Ref to track current vehicle ID for socket event handlers
  const currentVehicleIdRef = useRef(null);

  const { auctionId, auctionLaneId } = useParams();

  // Fallback: if route params are not available, try to get from carDetail or other sources
  const effectiveAuctionId =
    auctionId || carDetail?.auctionId || carDetail?.auction?.id;
  const effectiveAuctionLaneId =
    auctionLaneId || carDetail?.auctionLaneId || carDetail?.auctionLane?.id;

  // Socket connection state
  const {
    isConnected,
    isConnecting,
    currentAuctionLaneId,
    connect,
    disconnect,
    joinAuctionLane,
    leaveAuctionLane,
    placeBid,
    onNewBid,
    onJoinedAuctionLane,
    onLeftAuctionLane,
    onBidConfirmation,
    onBidDeleted,
    onBidEdited,
    onError,
    onVehicleSold,
    onVehicleCancelled,
    onRedPulsingStarted,
    onGreenPulsingStarted,
    onPulsingStopped,
    onAuctionStarted,
    onAuctionPaused,
    onAuctionResumed,
    onAuctionStatusChanged,
    onAuctionEnded,
    onPeriodicUpdate,
    onPeriodicUpdatesStarted,
    onPeriodicUpdatesStopped,
    onTimerState,
    getTimerState,
    onTimerReset,
    onTimerAutoReset,
    getPulsingStatus,
    onPulsingStatus,
  } = useClientSocket();

  // Auction details state
  const [auctionDetails, setAuctionDetails] = useState(null);
  const [currentVehicle, setCurrentVehicle] = useState(null);
  const [vehicleList, setVehicleList] = useState([]);
  const [isLoadingAuctionDetails, setIsLoadingAuctionDetails] = useState(false);
  const [auctionDetailsError, setAuctionDetailsError] = useState(null);
// tueesday fix green pulse for reserved not working 
  const currentVehicleRef = useRef(null);
  const winningBidRef = useRef(null);
  const currentBidsRef = useRef([]);

  const getLatestCurrentBidValue = () => {
    const vehicle = currentVehicleRef.current;
    const winningAmount = Number(winningBidRef.current?.amount || 0);
    if (winningAmount > 0) return winningAmount;

    const latestWinningBid = currentBidsRef.current?.find((bid) => bid.isWinningBid)?.amount;
    if (Number(latestWinningBid) > 0) return Number(latestWinningBid);

    const latestBid = currentBidsRef.current?.[0]?.amount;
    if (Number(latestBid) > 0) return Number(latestBid);

    return Number(vehicle?.currentBid || vehicle?.latestBid || vehicle?.startingBid || 0);
  };

  // tueday end 

  // Bidding state
  const [currentBids, setCurrentBids] = useState([]);
  const [winningBid, setWinningBid] = useState(null);
  const [isPlacingBid, setIsPlacingBid] = useState(false);
  const [isLoadingBidHistory, setIsLoadingBidHistory] = useState(false);

  // Notification state
  const [showBidSuccess, setShowBidSuccess] = useState(false);
  const [lastBidAmount, setLastBidAmount] = useState(0);
  const [bidErrorMessage, setBidErrorMessage] = useState(null);
  const [showBidErrorMessage, setShowBidErrorMessage] = useState(false);

  // Pulsing animation state
  const [isRedPulsing, setIsRedPulsing] = useState(false);
  const [isGreenPulsing, setIsGreenPulsing] = useState(false);

  // Timer state (now synchronized with server)
  const [localAuctionStatus, setLocalAuctionStatus] = useState(
    auctionDetails?.auctionLanes[0]?.auctionStatus?.slug || "scheduled"
  );
  const [currentPauseMessage, setCurrentPauseMessage] = useState(null);
  const [showPauseOverlay, setShowPauseOverlay] = useState(false);

  // Server-side timer state
  const [serverTimer, setServerTimer] = useState({
    isRunning: false,
    timeRemaining: 0,
    duration: 0,
    isPaused: false,
  });

  // Timer state request state
  const [isRequestingTimerState, setIsRequestingTimerState] = useState(false);

  // Ref to store the reset manual bid function from CurrentBidBox
  const resetManualBidRef = useRef(null);

  // Auction completed state
  const [isAuctionCompleted, setIsAuctionCompleted] = useState(false);

  // Confetti hook
  const { fireConfetti, fireConfettiBurst } = useConfetti();

  // Win notification state
  const [showWinNotification, setShowWinNotification] = useState(false);
  const [showUnderApprovalNotification, setShowUnderApprovalNotification] =
    useState(false);
  const [showBuyNowNotification, setShowBuyNowNotification] = useState(false);

  // Track bidder IDs for current vehicle
  const [currentVehicleBidderIds, setCurrentVehicleBidderIds] = useState([]);

  // Get current user ID from localStorage
  const getCurrentUserId = useCallback(() => {
    try {
      const authUser = localStorage.getItem("authUser");
      if (authUser) {
        const user = JSON.parse(authUser);
        return user?.id || user?.user?.id || null;
      }
    } catch (error) {
      console.error("Error getting current user ID:", error);
    }
    return null;
  }, []);

  const currentUserIdRef = useRef(getCurrentUserId());
// tueesday fix green pulse for reserved not working 
  useEffect(() => {
    currentVehicleRef.current = currentVehicle;
  }, [currentVehicle]);

  useEffect(() => {
    winningBidRef.current = winningBid;
  }, [winningBid]);

  useEffect(() => {
    currentBidsRef.current = currentBids;
  }, [currentBids]);
  // End tueesday fix

  // Track previous winning bidder to detect when current user loses bid
  const previousWinningBidderIdRef = useRef(null);
  // Track current winning bidder ID for reliable checking
  const currentWinningBidderIdRef = useRef(null);

  // Watchlist state
  const [watchlistVehicleIds, setWatchlistVehicleIds] = useState(new Set());
  const watchlistVehicleIdsRef = useRef(new Set());
  const hasPlayedTwoCarsAwaySoundRef = useRef(new Set()); // Track which vehicles already played the "2 cars away" sound
  const hasPlayedCarArrivedSoundRef = useRef(new Set()); // Track which vehicles already played the "car arrived" sound
  const lastProcessedVehicleRef = useRef(null); // Track last processed vehicle to prevent duplicate processing

 


  // Function to determine bid status based on user participation
  const getBidStatus = () => {
    const currentUserId = JSON.parse(
      localStorage.getItem("authUser") || "{}"
    )?.id;

    // If user is winning bid, show "Winning Bid"
    if (winningBid && winningBid.bidder?.id === currentUserId) {
      return "Winning Bid";
    }

    // Check if current user has placed any bids using the bidder IDs list
    const userHasBid = currentVehicleBidderIds.includes(currentUserId);

    if (userHasBid) {
      return "Bid Lost";
    } else {
      return "No Bids Yet";
    }
  };

  // Preload sounds on mount
  useEffect(() => {
    // Preload all sounds that will be used
    soundHelper.preloadSounds([
      "timer-reset.mp3",
      "new-bid.mp3",
      "vehicle-sold.mp3",
      "you-are-highest-bidder.mp3",
      "you-lost-the-bid.mp3",
      "congrats-you-won-car.mp3",
      "car-under-approval.mp3",
      "car-approved.mp3",
      "your-car-is-on-the-block.mp3",
      "car-arrived.mp3",
    ]);
  }, []);

  // Update current winning bidder ref when winningBid changes
  useEffect(() => {
    currentWinningBidderIdRef.current = winningBid?.bidder?.id || null;
  }, [winningBid]);

  // Reset winning bidder refs when vehicle changes
  useEffect(() => {
    if (currentVehicle) {
      currentVehicleIdRef.current = currentVehicle?.id || null;
      // Reset previous winning bidder when vehicle changes
      previousWinningBidderIdRef.current = null;
      currentWinningBidderIdRef.current = null;
    }
  }, [currentVehicle]);

  // Fetch watchlist on component mount
  useEffect(() => {
    const fetchWatchlist = async () => {
      try {
        const authUser = localStorage.getItem("authUser");
        if (!authUser) return;

        const user = JSON.parse(authUser);
        const userId = user?.id || user?.user?.id;
        if (!userId) return;

        const response = await api.get("/wishlist");
        const wishlistData = response.data?.data || response.data;

        if (wishlistData && Array.isArray(wishlistData)) {
          const vehicleIds = new Set(
            wishlistData.map((item) => item.vehicleId)
          );
          setWatchlistVehicleIds(vehicleIds);
          watchlistVehicleIdsRef.current = vehicleIds;
        }
      } catch (error) {
        console.error("Error fetching watchlist:", error);
      }
    };

    fetchWatchlist();
  }, []);

  // Check for watchlist cars when current vehicle or vehicle list changes
  // Only play sounds when auction is active (ongoing and not paused)
  useEffect(() => {
    // Use a timeout to debounce rapid effect calls
    const timeoutId = setTimeout(() => {
      if (!currentVehicle || !vehicleList || vehicleList.length === 0) return;

      // Only play sounds when auction is ongoing and not paused
      const isAuctionActive =
        localAuctionStatus === "ongoing" && !serverTimer.isPaused;

      if (!isAuctionActive) {
        // Reset last processed vehicle when auction is not active
        lastProcessedVehicleRef.current = null;
        return;
      }

      const currentVehicleId = currentVehicle.id;
      const watchlistIds = watchlistVehicleIdsRef.current;

      if (watchlistIds.size === 0) return;

      // Prevent duplicate processing for the same vehicle in the same auction state
      const processingKey = `${currentVehicleId}-${localAuctionStatus}-${serverTimer.isPaused}`;
      if (lastProcessedVehicleRef.current === processingKey) {
        return; // Already processed this exact state
      }

      // Sort vehicle list by runNo if available, otherwise use array index
      const sortedVehicleList = [...vehicleList].sort((a, b) => {
        const runNoA = a?.auctionLanesVehicles?.[0]?.runNo || a?.runNo || 0;
        const runNoB = b?.auctionLanesVehicles?.[0]?.runNo || b?.runNo || 0;
        return runNoA - runNoB;
      });

      // Find current vehicle index in the sorted vehicle list
      const currentIndex = sortedVehicleList.findIndex(
        (v) => v.id === currentVehicleId
      );

      if (currentIndex === -1) return;

      // Check if current vehicle is in watchlist (car arrived)
      if (
        watchlistIds.has(currentVehicleId) &&
        !hasPlayedCarArrivedSoundRef.current.has(currentVehicleId)
      ) {
        // Mark this vehicle as having played the sound BEFORE playing
        // This prevents duplicate plays if the effect runs again quickly
        hasPlayedCarArrivedSoundRef.current.add(currentVehicleId);

        // Play car arrived sound
        soundHelper.playSound("car-arrived.mp3", {
          volume: 0.8,
          onError: (error) => {
            console.warn("Failed to play car arrived sound:", error);
          },
        });
      }

      // Check if any watchlist car is 2 cars away
      // Look ahead 2 positions in the sorted vehicle list
      const twoCarsAheadIndex = currentIndex + 2;
      if (
        twoCarsAheadIndex < sortedVehicleList.length &&
        sortedVehicleList[twoCarsAheadIndex]
      ) {
        const twoCarsAheadVehicleId = sortedVehicleList[twoCarsAheadIndex].id;

        // Check if this vehicle is in watchlist and hasn't played the sound yet
        if (
          watchlistIds.has(twoCarsAheadVehicleId) &&
          !hasPlayedTwoCarsAwaySoundRef.current.has(twoCarsAheadVehicleId)
        ) {
          // Mark this vehicle as having played the sound BEFORE playing
          // This prevents duplicate plays if the effect runs again quickly
          hasPlayedTwoCarsAwaySoundRef.current.add(twoCarsAheadVehicleId);

          // Play "your car is on the block" sound (loud)
          soundHelper.playSound("your-car-is-on-the-block.mp3", {
            volume: 1.0, // Loud volume
            onError: (error) => {
              console.warn(
                "Failed to play your car is on the block sound:",
                error
              );
            },
          });
        }
      }

      // Mark this state as processed
      lastProcessedVehicleRef.current = processingKey;
    }, 100); // Small delay to debounce rapid changes

    return () => clearTimeout(timeoutId);
  }, [currentVehicle, vehicleList, localAuctionStatus, serverTimer.isPaused]);

  // Connect to socket when component mounts
  useEffect(() => {
    connect();

    return () => {
      console.log("LiveBidPage: Component unmounting, disconnecting socket");
      disconnect();
    };
  }, [connect, disconnect]);

  // Join auction lane when socket connects
  useEffect(() => {
    if (isConnected && effectiveAuctionLaneId) {
      joinAuctionLane(effectiveAuctionLaneId);
    }
  }, [isConnected, effectiveAuctionLaneId, joinAuctionLane]);

  // Reset sound tracking when vehicle list changes (new auction or refresh)
  useEffect(() => {
    hasPlayedTwoCarsAwaySoundRef.current.clear();
    hasPlayedCarArrivedSoundRef.current.clear();
    lastProcessedVehicleRef.current = null;
  }, [vehicleList]);

  // Fetch auction details when auctionLaneId changes
  useEffect(() => {
    if (effectiveAuctionLaneId && isConnected) {
      fetchAuctionDetails();
    }
  }, [effectiveAuctionLaneId, isConnected]);

  // Request current timer state from server
  const handleGetTimerState = () => {
    if (!isConnected || !effectiveAuctionLaneId) {
      console.error(
        "Cannot get timer state: Socket not connected or missing auction lane ID"
      );
      return;
    }

    setIsRequestingTimerState(true);
    try {
      getTimerState(effectiveAuctionLaneId);
    } catch (error) {
      console.error("Error requesting timer state:", error);
      // Only clear loading state on error, not on success
      // Success will clear it when the socket response arrives
      setIsRequestingTimerState(false);
    }
  };

  // Request current pulsing status from server
  const handleGetPulsingStatus = () => {
    if (!isConnected || !effectiveAuctionLaneId) {
      console.error(
        "Cannot get pulsing status: Socket not connected or missing auction lane ID"
      );
      return;
    }
    try {
      getPulsingStatus(effectiveAuctionLaneId);
    } catch (error) {
      console.error("Error requesting pulsing status:", error);
    }
  };

  // Request timer state when auction lane changes
  useEffect(() => {
    if (effectiveAuctionLaneId && isConnected) {
      // Small delay to ensure socket is fully ready
      const timer = setTimeout(() => {
        handleGetTimerState();
        handleGetPulsingStatus();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [effectiveAuctionLaneId, isConnected]);

  // Function to fetch bid history for current vehicle
  const fetchBidHistory = async () => {
    if (!effectiveAuctionLaneId || !currentVehicleIdRef.current) {
      console.warn(
        "LiveBidPage: No effectiveAuctionLaneId or currentVehicleId available for fetching bid history"
      );
      return;
    }

    try {
      setIsLoadingBidHistory(true);
      const bidHistory = await getBidHistory(
        effectiveAuctionLaneId,
        currentVehicleIdRef.current
      );
      setCurrentBids(bidHistory?.data || []);
      const winning = bidHistory?.data?.find((bid) => bid.isWinningBid);
      setWinningBid(winning || null);

      // Initialize winning bidder references when loading bid history
      if (winning) {
        previousWinningBidderIdRef.current = winning.bidder.id;
        currentWinningBidderIdRef.current = winning.bidder.id;
      } else {
        previousWinningBidderIdRef.current = null;
        currentWinningBidderIdRef.current = null;
      }

      // Extract unique bidder IDs from bid history
      const bidderIds = [
        ...new Set(
          (bidHistory?.data || [])
            .map((bid) => bid.bidder?.id)
            .filter((id) => id)
        ),
      ];
      setCurrentVehicleBidderIds(bidderIds);
    } catch (error) {
      console.warn("LiveBidPage: Could not fetch updated bid history:", error);
    } finally {
      setIsLoadingBidHistory(false);
    }
  };

  // Function to fetch auction details
  const fetchAuctionDetails = async () => {
    if (!effectiveAuctionLaneId) {
      console.warn(
        "LiveBidPage: No effectiveAuctionLaneId available for fetching details"
      );
      return;
    }

    if (!effectiveAuctionId) {
      console.warn(
        "LiveBidPage: No effectiveAuctionId available for fetching details"
      );
    }

    try {
      setIsLoadingAuctionDetails(true);
      setAuctionDetailsError(null);

      // Fetch auction details if auctionId is available
      let auctionData = null;
      if (effectiveAuctionId) {
        try {
          auctionData = await getAuction(
            effectiveAuctionId,
            effectiveAuctionLaneId
          );
          setAuctionDetails(auctionData);
        } catch (error) {
          console.warn("LiveBidPage: Could not fetch auction data:", error);
        }
      }

      // // Fetch auction lane details
      // const laneDetails = await getAuctionLaneWithDetails(
      //   effectiveAuctionLaneId
      // );

      // // Combine the data
      // const combinedDetails = {
      //   auction: auctionData,
      //   lane: laneDetails?.lane,
      //   auctionStatus: laneDetails?.auctionStatus,
      //   auctionLanes: auctionData?.lanes || [],
      // };

      // setAuctionDetails(combinedDetails);

      //        // Fetch current vehicle
      const vehicle = await getCurrentVehicle(effectiveAuctionLaneId);
      setCurrentVehicle(vehicle);
      currentVehicleIdRef.current = vehicle?.id;

      // Fetch bid history for current vehicle
      if (vehicle?.id) {
        try {
          setIsLoadingBidHistory(true);
          const bidHistory = await getBidHistory(
            effectiveAuctionLaneId,
            vehicle.id
          );
          setCurrentBids(bidHistory?.data || []);
          const winning = bidHistory?.data?.find((bid) => bid.isWinningBid);
          setWinningBid(winning || null);

          // Initialize winning bidder references when loading bid history
          if (winning) {
            previousWinningBidderIdRef.current = winning.bidder.id;
            currentWinningBidderIdRef.current = winning.bidder.id;
          } else {
            previousWinningBidderIdRef.current = null;
            currentWinningBidderIdRef.current = null;
          }

          // Extract unique bidder IDs from bid history
          const bidderIds = [
            ...new Set(
              (bidHistory?.data || [])
                .map((bid) => bid.bidder?.id)
                .filter((id) => id)
            ),
          ];
          setCurrentVehicleBidderIds(bidderIds);
        } catch (error) {
          console.warn("LiveBidPage: Could not fetch bid history:", error);
        } finally {
          setIsLoadingBidHistory(false);
        }
      }

      // // Fetch vehicle list
      const vehicles = await getVehicleList(effectiveAuctionLaneId);
      setVehicleList(vehicles?.data);

      // check if all cars are sold
      const allCarsSold = vehicles?.data?.every(
        (car) => car.productAuctionStatusId != 2
      );
      setAllCarsSold(allCarsSold);
      setIsAuctionCompleted(allCarsSold);
    } catch (error) {
      console.error("LiveBidPage: Error fetching auction details:", error);
      setAuctionDetailsError(
        error.message || "Failed to fetch auction details"
      );

      // Log more details for debugging
      if (error.response) {
        console.error("Error response:", error.response.data);
        console.error("Error status:", error.response.status);
      }
    } finally {
      setIsLoadingAuctionDetails(false);
    }
  };

  // Socket event handlers
  useEffect(() => {
    if (!isConnected) return;

    // Handle successful auction lane join
    const unsubscribeJoined = onJoinedAuctionLane((data) => {
      if (data.auctionLaneId == effectiveAuctionLaneId) {
        // Handle auction state from join response
        if (data.auctionState) {
          // Update local auction status
          setLocalAuctionStatus(data.auctionState.status);

          // Set pause message and overlay if auction is paused
          if (data.auctionState.isPaused && data.auctionState.pauseMessage) {
            setCurrentPauseMessage(data.auctionState.pauseMessage);
            setShowPauseOverlay(true);
          }
        }

        // Fetch auction details after successful join
        fetchAuctionDetails();
        // Get initial pulsing status
        handleGetPulsingStatus();
      }
    });

    // Handle leaving auction lane
    const unsubscribeLeft = onLeftAuctionLane((data) => {
      console.log("LiveBidPage: Left auction lane:", data);
    });

    // Handle new bids
    const unsubscribeNewBid = onNewBid((data) => {
      if (data.vehicleId == currentVehicleIdRef.current) {
        const currentUserId = currentUserIdRef.current;
        const previousWinningBidderId = previousWinningBidderIdRef.current;
        const newWinningBidderId = data.userId;

        // Get current winning bidder from ref (always up-to-date)
        const currentWinningBidderId = currentWinningBidderIdRef.current;

        // Check if current user lost the bid (was CURRENTLY winning, now someone else is winning)
        // Only check currentWinningBidderId, not previousWinningBidderId, to avoid playing sound multiple times
        const wasCurrentlyWinning = currentWinningBidderId === currentUserId;

        if (
          wasCurrentlyWinning &&
          newWinningBidderId !== currentUserId &&
          data.isWinningBid &&
          currentUserId !== null
        ) {
          // Current user lost the bid - play sound only once
          soundHelper.playSound("you-lost-the-bid.mp3", {
            volume: 0.7,
            onError: (error) => {
              console.warn("Failed to play lost bid sound:", error);
            },
          });
        }

        // Check if current user is now the highest bidder
        if (
          newWinningBidderId === currentUserId &&
          data.isWinningBid &&
          currentWinningBidderId !== currentUserId &&
          currentUserId !== null
        ) {
          // Current user became the highest bidder
          soundHelper.playSound("you-are-highest-bidder.mp3", {
            volume: 0.7,
            onError: (error) => {
              console.warn("Failed to play highest bidder sound:", error);
            },
          });
        }

        // Update both refs when new winning bid comes in
        if (data.isWinningBid) {
          previousWinningBidderIdRef.current =
            currentWinningBidderId || newWinningBidderId;
          currentWinningBidderIdRef.current = newWinningBidderId;
        }

        // Update bidder IDs list if provided
        if (data.bidderIds) {
          setCurrentVehicleBidderIds(data.bidderIds);
        }

        // Add new bid to bid history
        const newBid = {
          id: data.bidId || Date.now(),
          amount: data.amount,
          bidder: {
            id: data.userId,
            name: data.userName || "Unknown",
            email: data.userEmail || "",
          },
          createdAt: data.createdAt || new Date().toISOString(),
          isWinningBid: data.isWinningBid || false,
        };

        setCurrentBids((prev) => [newBid, ...prev.slice(0, 9)]);

        // Play new bid sound (for all users)
        soundHelper.playSound("new-bid.mp3", {
          volume: 0.6,
          onError: (error) => {
            console.warn("Failed to play new bid sound:", error);
          },
        });

        // Hide bid success notification when new bid is received from someone else
        const currentUserIdFromStorage = JSON.parse(
          localStorage.getItem("authUser") || "{}"
        )?.id;
        if (data.userId !== currentUserIdFromStorage) {
          setShowBidSuccess(false);
        }

        // Update winning bid if this is the new winning bid
        if (data.isWinningBid) {
          setWinningBid(newBid);

          // Reset manual bid input when new winning bid is received
          if (resetManualBidRef.current) {
            setTimeout(() => {
              resetManualBidRef.current();
            }, 100);
          }

          // Show notification for new winning bid from other users
          if (
            data.userId !==
            JSON.parse(localStorage.getItem("authUser") || "{}")?.id
          ) {
            setLastBidAmount(data.amount);
            // setShowBidSuccess(true);
            // setTimeout(() => {
            //   setShowBidSuccess(false);
            // }, 3000);
          }
        }
      }
    });

    // Handle bid confirmation from server
    const unsubscribeBidConfirmation = onBidConfirmation?.((data) => {
      if (data.vehicleId == currentVehicleIdRef.current) {
        // Update local state with confirmed bid
        setCurrentBids((prev) => {
          const updatedBids = prev.map((bid) =>
            bid.id == data.bidId ? { ...bid, confirmed: true } : bid
          );
          return updatedBids;
        });
      }
    });

    // Handle bid deleted from server
    const unsubscribeBidDeleted = onBidDeleted?.((data) => {
      if (data.vehicleId == currentVehicleIdRef.current) {
        // Fetch updated bid history after bid deletion
        fetchBidHistory();
      }
    });

    // Handle bid edited from server
    const unsubscribeBidEdited = onBidEdited?.((data) => {
      if (data.vehicleId == currentVehicleIdRef.current) {
        // Fetch updated bid history after bid editing
        fetchBidHistory();
      }
    });

    // Handle errors
    const unsubscribeError = onError((data) => {
      setShowBidSuccess(false);
      if (data.errorCode == "AUCTION_COMPLETED") {
        setIsAuctionCompleted(true);
      }
      if (data.errorCode == "NO_BUYER_LIMITS") {
        setBidErrorMessage(data.message);
        setShowBidErrorMessage(true);
      }
      console.error("LiveBidPage: Socket error:", data);
    });

    // Handle vehicle sold
    const unsubscribeVehicleSold = onVehicleSold((data) => {
      console.log("Vehicle sold:", data);

      const currentUser = JSON.parse(localStorage.getItem("authUser") || "{}");
      const currentUserId = currentUserIdRef.current;
      const isUnderApproval =
        data.isUnderApproval === true ||
        data.message?.toLowerCase().includes("under approval") ||
        data.message?.toLowerCase().includes("sent for approval") ||
        data.message === "Sent for Approval";

      // Check if current user won the car (was the winning bidder)
      const wasWinningBidder =
        winningBid?.bidder?.id === currentUserId ||
        data.soldTo == currentUser?.buyer?.id;

      // Handle sounds based on approval status
      if (isUnderApproval) {
        // Car moved to under approval - play approved sound for winning user only
        if (wasWinningBidder) {
          soundHelper.playSound("car-approved.mp3", {
            volume: 0.7,
            onError: (error) => {
              console.warn("Failed to play car approved sound:", error);
            },
          });
          setShowUnderApprovalNotification(true);
          // Auto-hide notification after 4 seconds
          setTimeout(() => {
            setShowUnderApprovalNotification(false);
          }, 6000);
        }
        // Don't play vehicle-sold sound for approval cases
        // Note: "car-under-approval.mp3" is played when red pulsing starts (for all users)
      } else {
        // Car sold normally (not under approval)
        // Play vehicle sold sound for all users
        soundHelper.playSound("vehicle-sold.mp3", {
          volume: 0.7,
          onError: (error) => {
            console.warn("Failed to play vehicle sold sound:", error);
          },
        });

        // Play congratulations sound if current user won the car
        if (wasWinningBidder) {
          soundHelper.playSound("congrats-you-won-car.mp3", {
            volume: 0.7,
            onError: (error) => {
              console.warn("Failed to play won car sound:", error);
            },
          });
          // Show win notification
          setShowWinNotification(true);
          // Fire confetti explosion from sides
          fireConfettiBurst();
          // Auto-hide notification after 4 seconds
          setTimeout(() => {
            setShowWinNotification(false);
          }, 6000);
        }
      }

      // Reset previous winning bidder when vehicle is sold
      previousWinningBidderIdRef.current = null;
      currentWinningBidderIdRef.current = null;

      if (data.auctionLaneId == effectiveAuctionLaneId) {
        if (data.isLastVehicle) {
          // All vehicles sold
          setAllCarsSold(true);
        }

        // Clear current bids for the sold vehicle
        setCurrentBids([]);
        setWinningBid(null);
        setCurrentVehicleBidderIds([]);
        // Clear current vehicle ref temporarily
        currentVehicleIdRef.current = null;

        if (data.isLastVehicle) {
          // All vehicles sold - clear current vehicle and refresh vehicle list
          setCurrentVehicle(null);
          currentVehicleIdRef.current = null;

          // Refresh vehicle list to show updated status
          setTimeout(async () => {
            try {
              const vehicles = await getVehicleList(effectiveAuctionLaneId);
              setVehicleList(vehicles?.data || []);
            } catch (error) {
              console.error(
                "Error refreshing vehicle list after last vehicle sold:",
                error
              );
            }
          }, 1000);
        } else {
          // Load new current vehicle but DON'T reload vehicle list
          // The vehicle list is already updated locally
          setTimeout(async () => {
            fetchAuctionDetails();
            // Get updated pulsing status for new vehicle
            setTimeout(() => {
              handleGetPulsingStatus();
            }, 500);
          }, 1000); // Increased delay to ensure backend cache is updated
        }
      }
    });

    // Handle vehicle cancelled
    const unsubscribeVehicleCancelled = onVehicleCancelled((data) => {
      console.log("Vehicle cancelled:", data);

      if (data.auctionLaneId == effectiveAuctionLaneId) {
        if (data.status == "BUY_NOW") {
          setShowBuyNowNotification(true);
          // Auto-hide notification after 4 seconds
          setTimeout(() => {
            setShowBuyNowNotification(false);
          }, 6000);
        }

        if (data.isLastVehicle) {
          // All vehicles cancelled
          setAllCarsSold(true);
        } else {
          // Regular vehicle cancelled
        }

        // Clear current bids for the cancelled vehicle
        setCurrentBids([]);
        setWinningBid(null);
        setCurrentVehicleBidderIds([]);
        // Clear current vehicle ref temporarily
        currentVehicleIdRef.current = null;

        if (data.isLastVehicle) {
          // All vehicles cancelled - clear current vehicle and refresh vehicle list
          setCurrentVehicle(null);
          currentVehicleIdRef.current = null;

          // Refresh vehicle list to show updated status
          setTimeout(async () => {
            try {
              const vehicles = await getVehicleList(effectiveAuctionLaneId);
              setVehicleList(vehicles?.data || []);
            } catch (error) {
              console.error(
                "Error refreshing vehicle list after last vehicle cancelled:",
                error
              );
            }
          }, 1000);
        } else {
          // Load new current vehicle but DON'T reload vehicle list
          // The vehicle list is already updated locally
          setTimeout(async () => {
            fetchAuctionDetails();
            // Get updated pulsing status for new vehicle
            setTimeout(() => {
              handleGetPulsingStatus();
            }, 500);
          }, 1000); // Increased delay to ensure backend cache is updated
        }
      }
    });

    // Pulsing animation event handlers
    const unsubscribeRedPulsingStarted = onRedPulsingStarted((data) => {
      if (data.auctionLaneId == effectiveAuctionLaneId) {
        setIsRedPulsing(true);
        setIsGreenPulsing(false);

        // Play under approval sound for all users when red pulsing starts
        soundHelper.playSound("car-under-approval.mp3", {
          volume: 0.7,
          onError: (error) => {
            console.warn("Failed to play car under approval sound:", error);
          },
        });
      }
    });

    // const unsubscribeGreenPulsingStarted = onGreenPulsingStarted((data) => {
    //   if (data.auctionLaneId == effectiveAuctionLaneId) {
    //     setIsGreenPulsing(true);
    //     setIsRedPulsing(false);
    //   }
    // });

    //====== tueesday fix green pulse for reserved not working 
    const unsubscribeGreenPulsingStarted = onGreenPulsingStarted((data) => {
      if (data.auctionLaneId == effectiveAuctionLaneId) {
        const vehicle = currentVehicleRef.current;
        if (!vehicle) return;

        const reservedPrice = vehicle?.reservedPrice || 0;
        const currentBid = getLatestCurrentBidValue();

        const isEligible =
          reservedPrice === 0 || currentBid >= reservedPrice;

        // ✅ ONLY allow green pulse if condition satisfied
        if (isEligible) {
          setIsGreenPulsing(true);
          setIsRedPulsing(false);
        } else {
          // ❌ Block green pulse if reserve not met
          setIsGreenPulsing(false);
        }
      }
    });
//====== end tueesday fix
    const unsubscribePulsingStopped = onPulsingStopped((data) => {
      if (data.auctionLaneId == effectiveAuctionLaneId) {
        console.log("Pulsing stopped:", data);
        if (data.animationType == "red") {
          setIsRedPulsing(false);
        } else if (data.animationType == "green") {
          setIsGreenPulsing(false);
        } else if (data.animationType == "all") {
          // Stop all pulsing animations
          setIsRedPulsing(false);
          setIsGreenPulsing(false);
        }
      }
    });

    // Handle auction started event
    const unsubscribeAuctionStarted = onAuctionStarted((data) => {
      if (data.auctionLaneId == effectiveAuctionLaneId) {
        setLocalAuctionStatus("ongoing");
        setShowPauseOverlay(false);

        // Update vehicle list if provided in event data
        if (data.data?.vehicleList) {
          setVehicleList(data.data.vehicleList);
        } else {
          // Load vehicle list if not provided in event
          setTimeout(async () => {
            try {
              const vehicles = await getVehicleList(effectiveAuctionLaneId);
              setVehicleList(vehicles?.data || []);
            } catch (error) {
              console.error(
                "Error loading vehicle list after auction started:",
                error
              );
            }
          }, 100);
        }

        // Load current vehicle and bid history
        setTimeout(async () => {
          try {
            const vehicle = await getCurrentVehicle(effectiveAuctionLaneId);
            setCurrentVehicle(vehicle);
            currentVehicleIdRef.current = vehicle?.id;

            if (vehicle?.id) {
              const bidHistory = await getBidHistory(
                effectiveAuctionLaneId,
                vehicle.id
              );
              setCurrentBids(bidHistory?.data || []);
              const winning = bidHistory?.data?.find((bid) => bid.isWinningBid);
              setWinningBid(winning || null);
            }
          } catch (error) {
            console.error(
              "Error refreshing data after auction started:",
              error
            );
          }
        }, 100);
      }
    });

    // Handle auction paused event
    const unsubscribeAuctionPaused = onAuctionPaused((data) => {
      if (data.auctionLaneId == effectiveAuctionLaneId) {
        setLocalAuctionStatus("paused");

        // Set pause message if provided in the event
        if (data.pauseMessage) {
          setCurrentPauseMessage(data.pauseMessage);
          setShowPauseOverlay(true);
        } else if (data.message) {
          setCurrentPauseMessage(data.message);
          setShowPauseOverlay(true);
        }

        // Refresh data if needed
        if (data.shouldRefreshData) {
          fetchAuctionDetails();
        }
      }
    });

    // Handle auction resumed event
    const unsubscribeAuctionResumed = onAuctionResumed((data) => {
      if (data.auctionLaneId == effectiveAuctionLaneId) {
        setLocalAuctionStatus("ongoing");

        // Clear pause message when auction resumes
        setCurrentPauseMessage(null);
        setShowPauseOverlay(false);

        // Update vehicle list if provided in event data
        if (data.data?.vehicleList) {
          setVehicleList(data.data.vehicleList);
        } else {
          // Load vehicle list if not provided in event
          setTimeout(async () => {
            try {
              const vehicles = await getVehicleList(effectiveAuctionLaneId);
              setVehicleList(vehicles?.data || []);
            } catch (error) {
              console.error(
                "Error loading vehicle list after auction resumed:",
                error
              );
            }
          }, 100);
        }

        // Load current vehicle and bid history
        setTimeout(async () => {
          try {
            const vehicle = await getCurrentVehicle(effectiveAuctionLaneId);
            setCurrentVehicle(vehicle);
            currentVehicleIdRef.current = vehicle?.id;

            if (vehicle?.id) {
              const bidHistory = await getBidHistory(
                effectiveAuctionLaneId,
                vehicle.id
              );
              setCurrentBids(bidHistory?.data || []);
              const winning = bidHistory?.data?.find((bid) => bid.isWinningBid);
              setWinningBid(winning || null);
            }
          } catch (error) {
            console.error(
              "Error refreshing data after auction resumed:",
              error
            );
          }
        }, 100);
      }
    });

    // Handle auction status changed event
    const unsubscribeAuctionStatusChanged = onAuctionStatusChanged((data) => {
      if (data.auctionLaneId == effectiveAuctionLaneId) {
        // Update local auction status
        setLocalAuctionStatus(data.newStatus.slug);

        // Handle pause message if this is a pause action
        if (data.action == "paused" && data.pauseMessage) {
          setCurrentPauseMessage(data.pauseMessage);
          setShowPauseOverlay(true);
        } else if (data.action == "resumed" || data.action == "started") {
          // Clear pause message when auction is resumed or started
          setCurrentPauseMessage(null);
          setShowPauseOverlay(false);
        }

        // Show toast notification for status change
        if (data.message) {
          // Use a more user-friendly message
          const friendlyMessage = data.message.replace(
            "Auction status changed to: ",
            ""
          );
          // toast.info(friendlyMessage);
        }
      }
    });

    // Handle periodic updates
    const unsubscribePeriodicUpdate = onPeriodicUpdate((data) => {
      // Only update server timer state if there are actual changes
      if (data.timer) {
        setServerTimer((prevTimer) => {
          // Check if timer data has actually changed
          const hasChanges =
            prevTimer.isRunning !== data.timer.isRunning ||
            prevTimer.timeRemaining !== data.timer.remainingTime ||
            prevTimer.duration !== data.timer.totalTime ||
            prevTimer.isPaused !== data.timer.isPaused;

          // Only update if there are actual changes
          if (hasChanges) {
            return {
              isRunning: data.timer.isRunning,
              timeRemaining: data.timer.remainingTime,
              duration: data.timer.totalTime,
              isPaused: data.timer.isPaused,
            };
          }

          // Return previous state if no changes
          return prevTimer;
        });

        // Only sync the circular timer if it's running and not paused
        if (timerRef.current && data.timer.isRunning && !data.timer.isPaused) {
          // Update circular timer to match server timer
          timerRef.current.reset(data.timer.remainingTime);
        }
      }
    });

    // Handle periodic updates started event
    const unsubscribePeriodicUpdatesStarted = onPeriodicUpdatesStarted?.(
      (data) => {
        if (data.auctionLaneId == effectiveAuctionLaneId) {
          // You can add a toast notification here if needed
        }
      }
    );

    // Handle periodic updates stopped event
    const unsubscribePeriodicUpdatesStopped = onPeriodicUpdatesStopped?.(
      (data) => {
        if (data.auctionLaneId == effectiveAuctionLaneId) {
          // Update server timer state when updates stop
          if (data.timer) {
            setServerTimer((prev) => ({
              ...prev,
              ...data.timer,
            }));
          }
        }
      }
    );

    // Handle timer state response
    const unsubscribeTimerState = onTimerState?.((data) => {
      if (data.auctionLaneId == effectiveAuctionLaneId) {
        setIsRequestingTimerState(false);
        if (data.timer) {
          setServerTimer({
            isRunning: data.timer.isRunning,
            timeRemaining: data.timer.remainingTime,
            duration: data.timer.totalTime,
            isPaused: data.timer.isPaused,
          });
        }
      }
    });

    const unsubscribeTimerReset = onTimerReset((data) => {
      if (data.auctionLaneId == effectiveAuctionLaneId) {
        // Reset the circular timer to full duration if totalTime is available
        if (timerRef.current && data.totalTime) {
          timerRef.current.reset(data.totalTime);
        }

        // Update server timer state if timer data is available
        if (data.totalTime && data.remainingTime) {
          setServerTimer((prev) => ({
            ...prev,
            totalTime: data.totalTime,
            remainingTime: data.remainingTime,
            isRunning: true,
            isPaused: false,
          }));
        }
      }
    });

    // Handle timer auto-reset events (when timer reaches 0 and auto-resets)
    const unsubscribeTimerAutoReset = onTimerAutoReset?.((data) => {
      if (data.auctionLaneId == effectiveAuctionLaneId) {
        // Play timer reset sound
        soundHelper.playSound("timer-reset.mp3", {
          volume: 0.7,
          onError: (error) => {
            console.warn("Failed to play timer reset sound:", error);
          },
        });

        // Update server timer state if timer data is available
        if (data.timer) {
          setServerTimer({
            isRunning: data.timer.isRunning,
            timeRemaining: data.timer.remainingTime,
            duration: data.timer.totalTime,
            isPaused: data.timer.isPaused,
          });

          // Sync the circular timer with server timer data
          if (
            timerRef.current &&
            data.timer.isRunning &&
            !data.timer.isPaused
          ) {
            timerRef.current.reset(data.timer.remainingTime);
          }
        }
      }
    });

    // Handle complete pulsing status events
    const unsubscribePulsingStatus = onPulsingStatus((data) => {
      if (data.auctionLaneId == effectiveAuctionLaneId) {
        // Update pulsing states based on server response
        if (data.redPulsing.isActive) {
          setIsRedPulsing(true);
          setIsGreenPulsing(false);
        } else {
          setIsRedPulsing(false);
        }
// if (data.greenPulsing.isActive) {
//           setIsGreenPulsing(true);
//           setIsRedPulsing(false);
//         } else {
//           setIsGreenPulsing(false);
//         }
// ====== tueesday fix green pulse for reserved not working
        if (data.greenPulsing.isActive) {
          const vehicle = currentVehicleRef.current;
          const reservedPrice = vehicle?.reservedPrice || 0;
          const currentBid = getLatestCurrentBidValue();
          const isEligible = reservedPrice === 0 || currentBid >= reservedPrice;

          if (isEligible) {
            setIsGreenPulsing(true);
            setIsRedPulsing(false);
          } else {
            setIsGreenPulsing(false);
          }
        } else {
          setIsGreenPulsing(false);
        }
        //tuesday end 
      }
    });

    const unsubscribeAuctionEnded = onAuctionEnded((data) => {
      if (data.auctionLaneId == effectiveAuctionLaneId) {
        setIsAuctionCompleted(true);
      }
    });

    return () => {
      unsubscribeJoined?.();
      unsubscribeLeft?.();
      unsubscribeNewBid?.();
      unsubscribeBidConfirmation?.();
      unsubscribeBidDeleted?.();
      unsubscribeBidEdited?.();
      unsubscribeError?.();
      unsubscribeVehicleSold?.();
      unsubscribeVehicleCancelled?.();
      unsubscribeRedPulsingStarted?.();
      unsubscribeGreenPulsingStarted?.();
      unsubscribePulsingStopped?.();
      unsubscribeAuctionStarted?.();
      unsubscribeAuctionPaused?.();
      unsubscribeAuctionResumed?.();
      unsubscribeAuctionStatusChanged?.();
      unsubscribePeriodicUpdate?.();
      unsubscribePeriodicUpdatesStarted?.();
      unsubscribePeriodicUpdatesStopped?.();
      unsubscribeTimerState?.();
      unsubscribeTimerReset?.();
      unsubscribeTimerAutoReset?.();
      unsubscribePulsingStatus?.();
      unsubscribeAuctionEnded?.();
    };
  }, [
    isConnected,
    effectiveAuctionLaneId,
    carDetail?.id,
    onJoinedAuctionLane,
    onLeftAuctionLane,
    onNewBid,
    onBidConfirmation,
    onBidDeleted,
    onBidEdited,
    onError,
    onVehicleSold,
    onVehicleCancelled,
    onRedPulsingStarted,
    onGreenPulsingStarted,
    onPulsingStopped,
    onAuctionStarted,
    onAuctionPaused,
    onAuctionResumed,
    onAuctionStatusChanged,
    onPeriodicUpdate,
    onPeriodicUpdatesStarted,
    onPeriodicUpdatesStopped,
    onTimerState,
    getTimerState,
    onTimerReset,
    onTimerAutoReset,
    onAuctionEnded,
  ]);

  // Handle placing a bid
  const handlePlaceBid = async (amount) => {
    if (
      !isConnected ||
      !effectiveAuctionLaneId ||
      !currentVehicleIdRef.current
    ) {
      console.warn("Cannot place bid: Socket not connected or missing data");
      return;
    }

    if (localAuctionStatus === "scheduled") {
      console.warn("Cannot place bid: Auction not started yet");
      return;
    }

    if (localAuctionStatus === "paused") {
      console.warn("Cannot place bid: Auction is paused");
      return;
    }

    if (isNaN(amount) || amount <= 0) {
      console.error("Invalid bid amount:", amount);
      return;
    }

    // Validate bid amount
    const minBidAmount =
      (winningBid?.amount || currentVehicle?.startingBid || 0) + 1;
    if (amount < minBidAmount) {
      console.error(`Bid must be at least ${minBidAmount}`);
      return;
    }

    setIsPlacingBid(true);
    try {
      // Place bid via socket
      placeBid(effectiveAuctionLaneId, currentVehicleIdRef.current, amount);

      // Show success notification
      setLastBidAmount(amount);
      setShowBidSuccess(true);
    } catch (error) {
      console.error("Error placing bid:", error);
    } finally {
      setIsPlacingBid(false);
    }
  };

  // Handle placing a bid with increment
  const handlePlaceBidWithIncrement = async (increment) => {
    const currentAmount =
      winningBid?.amount || currentVehicle?.startingBid || 0;
    const newBidAmount = currentAmount + increment;

    await handlePlaceBid(newBidAmount);
  };

  console.log(currentVehicle);
  const carInfoItems = [
    ["Make", currentVehicle?.MakeModel?.make?.name],
    ["Model", currentVehicle?.MakeModel?.name],
    ["Variant", currentVehicle?.variant?.name],
    ["Year", currentVehicle?.year],
    ["Lot Number", currentVehicle?.lotNumber],
    [
      "VIN Number",
      currentVehicle?.vinNumber && (
        <span style={{ whiteSpace: "nowrap", fontFamily: "monospace" }}>
          {maskVinNumber(currentVehicle?.vinNumber, 8)}
        </span>
      ),
    ],
    ["Primary Damage", currentVehicle?.primaryDamageType?.name],
    ["Secondary Damage", currentVehicle?.secondaryDamageType?.name],
    ["Milage", currentVehicle?.mileage],
    ["Cylinders", currentVehicle?.cylinder?.name],
    ["Specification", currentVehicle?.specification?.name],
    ["Engine Type", currentVehicle?.engine?.name],
    ["Drive Type", currentVehicle?.DriveLineType?.name],
    ["Transmission", currentVehicle?.TransmissionType?.name],
    [
      "Color (Interior)",
      currentVehicle?.InteriorColor?.color?.startsWith("#") ? (
        <div className="flex items-center gap-2">
          <span
            style={{
              display: "inline-block",
              width: 24,
              height: 24,
              background: currentVehicle?.InteriorColor?.color,
              border: "1px solid #ccc",
              borderRadius: "50%",
              verticalAlign: "middle",
            }}
            title={currentVehicle?.InteriorColor?.name}
          />
          <span className="text-gray-700 font-medium">
            {currentVehicle?.InteriorColor?.name || "-"}
          </span>
        </div>
      ) : (
        <span className="text-gray-700">-</span>
      ),
    ],
    [
      "Color (Exterior)",
      currentVehicle?.ExteriorColor?.color?.startsWith("#") ? (
        <div className="flex items-center gap-2">
          <span
            style={{
              display: "inline-block",
              width: 24,
              height: 24,
              background: currentVehicle?.ExteriorColor?.color,
              border: "1px solid #ccc",
              borderRadius: "50%",
              verticalAlign: "middle",
            }}
            title={currentVehicle?.ExteriorColor?.name}
          />
          <span className="text-gray-700 font-medium">
            {currentVehicle?.ExteriorColor?.name || "-"}
          </span>
        </div>
      ) : (
        <span className="text-gray-700">-</span>
      ),
    ],
    ["Vehicle Type", currentVehicle?.BodyType?.name],
    ["Fuel", currentVehicle?.fuelType?.name],
    ["Highlights", currentVehicle?.Highlight?.name],
  ].filter(
    ([label, value]) => value !== null && value !== undefined && value !== ""
  );
  const SectionHeader = ({ title, icon }) => (
    <h2 className="bg-darkGraybg text-white p-[10px] m-[-15px] mb-[10px] border-b-0 font-bold flex items-center gap-1 text-lg md:text-[18px]">
      <span>{icon}</span>
      {title}
    </h2>
  );

  return (
    <>
      {/* Notification Bar */}
      <NotifictionBar
        isLiveBidPage={true}
        auctionData={{
          auctionName: auctionDetails?.name || "Live Auction",
          laneName: auctionDetails?.auctionLanes?.[0]?.lane?.name || "-",
        }}
      />

      {/* Win Notification */}
      {showWinNotification && (
        <div className="fixed top-20 right-4 z-50 bg-green-500 text-white px-6 py-4 rounded-lg shadow-2xl animate-bounce">
          <div className="flex items-center gap-3">
            <div className="text-3xl">🎉</div>
            <div>
              <p className="font-bold text-lg">Congratulations!</p>
              <p className="text-sm">You have won a car!</p>
            </div>
          </div>
        </div>
      )}

      {/* Win Notification */}
      {showUnderApprovalNotification && (
        <div className="fixed top-20 right-4 z-50 bg-yellow-500 text-white px-6 py-4 rounded-lg shadow-2xl animate-bounce">
          <div className="flex items-center gap-3">
            <div>
              <p className="font-bold text-lg">Under Approval</p>
              <p className="text-sm">
                Your bid was approved and vehicle is under approval
              </p>
            </div>
          </div>
        </div>
      )}
      {showBuyNowNotification && (
        <div className="fixed top-20 right-4 z-50 bg-yellow-500 text-white px-6 py-4 rounded-lg shadow-2xl animate-bounce">
          <div className="flex items-center gap-3">
            <div>
              <p className="font-bold text-lg">Buy Now</p>
              <p className="text-sm">Vehicle moved to buy now</p>
            </div>
          </div>
        </div>
      )}

      {isAuctionCompleted || allCarsSold ? (
        <div className="bg-red-100 mx-10 py-5 flex flex-col items-center justify-center border border-red-300 mt-10 mb-10">
          <div className="text-xl font-bold text-red-500">
            Auction Completed
          </div>
          <div className="text-3xl font-bold text-gray-500">
            {auctionDetails?.auctionLanes[0]?.auction?.name}
            <span className="text-primary">
              {" :  " + auctionDetails?.auctionLanes[0]?.lane?.name}
            </span>
          </div>
        </div>
      ) : (
        <div className="bg-gray-50 min-h-screen">
          {/* Font Awesome CDN for icons */}
          <link
            rel="stylesheet"
            href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css"
          />
          <CarHeader
            car={currentVehicle}
            auctionLane={auctionDetails?.auctionLanes[0]}
            vehicleList={vehicleList}
          />

          <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4 ">
            <div className="w-full max-w-7xl mx-auto">
              <div className="w-full shadow-md ">
                <div className="relative">
                  <CarImageGallery images={currentVehicle?.images} />
                </div>
              </div>
            </div>

            {/* Right: Info + Bid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 lg:max-h-[50vh]">
              <div className="border p-4 shadow-md bg-white">
                <SectionHeader title="Car Information" icon={carIcon} />
                <ul className="text-sm flex flex-col gap-4">
                  {carInfoItems.map(
                    ([label, value, isHighlight, valueClassName], idx) => (
                      <InfoItem
                        key={idx}
                        label={<span className="font-semibold">{label}</span>}
                        value={<span className="font-normal">{value}</span>}
                        valueClassName="font-normal"
                        icon={infoIcons[label]}
                        isHighlight={isHighlight}
                      />
                    )
                  )}
                </ul>
              </div>

              {/* Current Bid Box */}
              <div>
                <div className="relative z-0">
                  {showPauseOverlay && currentPauseMessage && (
                    <div className="absolute inset-0 bg-black bg-opacity-90 flex items-start justify-center z-10">
                      <div className="text-center text-white p-8 max-w-2xl mx-4">
                        <h2 className="text-2xl md:text-3xl font-bold mb-6">
                          Auction Paused
                        </h2>
                        <div className="font-light leading-relaxed border border-white p-4 rounded-lg">
                          {currentPauseMessage}
                        </div>
                        <div className="mt-6">
                          <div className="inline-flex items-center gap-2 bg-yellow-600 bg-opacity-90 px-4 py-2 rounded-full text-sm font-medium">
                            <i className="fas fa-clock"></i>
                            <span>Waiting for admin to resume auction</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {localAuctionStatus === "scheduled" && (
                    <div className="absolute inset-0 bg-black bg-opacity-90 flex items-start justify-center z-10">
                      <div className="text-center text-white p-8 max-w-2xl mx-4">
                        <h2 className="text-2xl md:text-3xl font-bold mb-6">
                          Auction Not Started Yet
                        </h2>
                        <div className="font-light leading-relaxed border border-white p-4 rounded-lg">
                          The auction is scheduled but has not started yet.
                          Please wait for the admin to start the auction.
                        </div>
                        <div className="mt-6">
                          <div className="inline-flex items-center gap-2 bg-blue-600 bg-opacity-90 px-4 py-2 rounded-full text-sm font-medium">
                            <i className="fas fa-clock"></i>
                            <span>Waiting for auction to start</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div>
                    {/* Fixed Notification Area - Always takes up space */}
                    <div className="min-h-[75px] flex items-center justify-center">
                      {/* Bid Success Notification */}
                      {showBidSuccess && (
                        <div className="z-50 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg animate-pulse w-full max-w-md">
                          <div className="flex items-center gap-2">
                            <i className="fas fa-check-circle text-xl"></i>
                            <div>
                              <p className="font-semibold">
                                Bid Placed Successfully!
                              </p>
                              <p className="text-sm">
                                Amount:{" "}
                                <CurrencyDisplay
                                  amount={lastBidAmount}
                                  size="small"
                                />{" "}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* No Bids Yet Notification */}
                      {!showBidSuccess && currentBids.length === 0 && (
                        <div className="z-50 bg-gray-500 text-white px-6 py-3 rounded-lg shadow-lg w-full max-w-md">
                          <div className="flex items-center gap-2">
                            <i className="fas fa-info-circle text-xl"></i>
                            <div>
                              <p className="font-semibold">No Bids Yet</p>
                              <p className="text-sm">
                                Be the first to place a bid on this vehicle
                              </p>
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Losing Bid Notification */}
                      {!showBidSuccess &&
                        currentBids.length > 0 &&
                        winningBid &&
                        winningBid.bidder?.id !==
                        JSON.parse(localStorage.getItem("authUser") || "{}")
                          ?.id && (
                          <div className="z-50 bg-[#ef4444] text-white px-6 py-3 rounded-lg shadow-lg w-full max-w-md">
                            <div className="flex items-center gap-2">
                              <i className="fas fa-exclamation-triangle text-xl"></i>
                              <div>
                                <p className="font-semibold">Losing Bid</p>
                                <p className="text-sm">
                                  Current winning bid:{" "}
                                  <CurrencyDisplay
                                    amount={winningBid.amount}
                                    size="small"
                                    signOptions={{ color: "white" }}
                                  />
                                </p>
                              </div>
                            </div>
                          </div>
                        )}
                    </div>
                    {/* All Cars Sold Notification */}
                    {allCarsSold && (
                      <div className="z-50 bg-red-500 text-white px-6 py-3 rounded-lg shadow-lg animate-pulse">
                        <div className="flex items-center gap-2">
                          <i className="fas fa-check-circle text-xl"></i>
                          <div>
                            <p className="font-semibold">All cars sold!</p>
                            <p className="text-sm">All cars have been sold.</p>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* Car under approval */}
                    {isRedPulsing && (
                      <div className="z-50 bg-red-500 text-white px-6 py-3 rounded-lg shadow-lg animate-pulse">
                        <div className="flex items-center gap-2">
                          <i className="fas fa-exclamation-circle text-xl"></i>
                          <div>
                            <p className="font-semibold">Car under approval!</p>
                          </div>
                        </div>
                      </div>
                    )}
                    {/* Auction not started notification */}
                    {localAuctionStatus === "scheduled" && (
                      <div className="z-50 bg-blue-500 text-white px-6 py-3 rounded-lg shadow-lg animate-pulse">
                        <div className="flex items-center gap-2">
                          <i className="fas fa-clock text-xl"></i>
                          <div>
                            <p className="font-semibold">
                              Auction Not Started Yet
                            </p>
                            <p className="text-sm">
                              Please wait for the admin to start the auction
                            </p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="mt-5 mb-5 flex justify-center items-center">
                    <CircularTimer
                      ref={timerRef}
                      totalSeconds={serverTimer.duration || 0}
                      remainingSeconds={serverTimer.timeRemaining || 0}
                      onTimeUp={() => console.log("Time's up!")}
                      size={180}
                      strokeWidth={10}
                      dataToDisplay={(() => {
                        const status = getBidStatus();
                        if (status === "Winning Bid") {
                          return (
                            <span className="px-4 py-2 rounded-full bg-green-500 text-white font-semibold text-lg">
                              Winning Bid
                            </span>
                          );
                        } else if (status === "Bid Lost") {
                          return (
                            <span className="px-4 py-2 rounded-full bg-red-500 text-white font-semibold text-lg">
                              Bid Lost
                            </span>
                          );
                        } else {
                          return (
                            <span className="px-4 py-2 rounded-full bg-gray-500 text-white font-semibold text-lg">
                              No Bids Yet
                            </span>
                          );
                        }
                      })()}
                    />

                    {/* <CircularTimer
                      ref={timerRef}
                      totalSeconds={serverTimer.duration || 0}
                      remainingSeconds={serverTimer.timeRemaining || 0}
                      onTimeUp={() => console.log("Time's up!")}
                      size={180}
                      strokeWidth={10}
                      dataToDisplay={serverTimer.timeRemaining}
                    /> */}
                  </div>

                  <CurrentBidBox
                    currentBid={
                      winningBid?.amount || currentVehicle?.startingBid || 0
                    }
                    onBid={handlePlaceBid}
                    onBidWithIncrement={handlePlaceBidWithIncrement}
                    isConnected={isConnected}
                    auctionLaneId={effectiveAuctionLaneId}
                    vehicleId={currentVehicleIdRef.current}
                    isPlacingBid={isPlacingBid}
                    winningBid={winningBid}
                    startingBid={currentVehicle?.startingBid || 0}
                    isRedPulsing={isRedPulsing}
                    isGreenPulsing={isGreenPulsing}
                    bidIncrement={currentVehicle?.bidIncrement || 10}
                    auctionStatus={localAuctionStatus}
                    onResetManualBid={(resetFn) => {
                      resetManualBidRef.current = resetFn;
                    }}
                    showBidErrorMessage={showBidErrorMessage}
                    bidErrorMessage={bidErrorMessage}
                    setShowBidErrorMessage={setShowBidErrorMessage}
                  />
                </div>
              </div>
            </div>
          </div>
          
          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 max-w-7xl 2xl:max-w-[90%] mx-auto mb-4 px-3 sm:px-4 lg:px-6">
            {/* Left: Main image */}
          </div>
          {/* Auction Cars & Bidding Activity */}
         
           <div className="my-10 max-w-7xl mx-auto grid grid-cols-1 gap-3 md:grid-cols-2 lg:grid-cols-4  items-start">
            {/* Auction Cars List */}
            <div className="col-span-1 md:col-span-2 lg:col-span-3">
              <AuctionVehicalsList
                title={`AUCTION VEHICLES (${auctionDetails?.auctionLanes[0]?.vehicleList?.length})`}
                cars={vehicleList}
                currentVehicleId={currentVehicleIdRef.current}
                currentUserId={
                  JSON.parse(localStorage.getItem("authUser") || "{}")?.buyer
                    ?.id
                }
              />
            </div>
            {/* Bidding Activity */}
            <BiddingActivityList bids={currentBids || []} />
          </div>
        </div>
      )}
    </>
  );
}
